/*
export function someMutation (state) {
}
*/

export function SET_MAPA_RISCO(state, obj) {
  state.mapaRisco = obj;
}
